import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

export default function PrivacyPage() {
  return (
    <LegalPageLayout title="Privacy Policy" effectiveDate="October 25, 2026">
      <section>
        <h2>1. Information we collect</h2>
        <ul>
          <li><strong>Account information:</strong> name, email address, password hash, verification status, role, optional typing-baseline information, and account preferences.</li>
          <li><strong>Document information:</strong> uploaded images, filenames, instructions, annotations, messages, OCR results, transcription text, review history, and export information.</li>
          <li><strong>Service activity:</strong> authentication activity, approximate online presence, credit balance and transaction metadata, referral attribution, processing status, and security or error logs.</li>
          <li><strong>Payment metadata:</strong> Stripe transaction identifiers, payment status, amounts, currency, and limited billing metadata. We do not receive or store complete payment-card numbers.</li>
        </ul>
      </section>

      <section>
        <h2>2. How we use information</h2>
        <p>We use information to authenticate accounts, process and enhance documents, coordinate transcription and review, deliver exports, operate credits and payments, prevent abuse, communicate about active work, troubleshoot failures, and maintain service security.</p>
      </section>

      <section>
        <h2>3. AI processing and human access</h2>
        <p>Document content may be sent to Google Gemini for OCR and image analysis and, when the configured fallback is needed, to a Hugging Face inference provider. Authorized transcribers and administrators may view content only when required to complete, review, support, or secure a document job.</p>
      </section>

      <section>
        <h2>4. Service providers</h2>
        <p>We use service providers to operate GetScribeDash, including Hostinger for hosting, MongoDB Atlas for database services, Google and Hugging Face for configured AI processing, Stripe for payments, and an email-delivery provider for account messages. These providers process information under their own terms and privacy practices. We do not sell uploaded documents or personal information.</p>
      </section>

      <section>
        <h2>5. Cookies and authentication</h2>
        <p>GetScribeDash uses secure, HTTP-only authentication cookies to maintain signed-in sessions. We also process limited request and security information needed to protect accounts and enforce abuse controls.</p>
      </section>

      <section>
        <h2>6. Retention and deletion requests</h2>
        <p>Account records, uploaded documents, generated text, and transaction records are retained while needed to provide and secure the service and to meet legitimate operational or legal obligations. The current application does not provide automatic self-service account deletion. You may request account or document deletion by emailing <a className="text-[var(--brand-primary)] hover:underline" href="mailto:admin@getscribedash.com">admin@getscribedash.com</a>. We will verify the requester and evaluate the request subject to applicable law, fraud prevention, dispute handling, backups, and required financial recordkeeping.</p>
      </section>

      <section>
        <h2>7. Security</h2>
        <p>We use access controls, encrypted network connections, hashed passwords, signed authentication tokens, restricted document routes, and payment-webhook signature verification. No online service can guarantee absolute security, so please avoid uploading content that is unnecessary for the requested work.</p>
      </section>

      <section>
        <h2>8. Your choices</h2>
        <p>You may update available account details in the application and contact us to ask about access, correction, or deletion of your information. Rights vary by location, and we may need to verify your identity before responding.</p>
      </section>

      <section>
        <h2>9. Policy changes and contact</h2>
        <p>We may update this policy as the service changes. The effective date above identifies the current version. Privacy questions may be sent to <a className="text-[var(--brand-primary)] hover:underline" href="mailto:admin@getscribedash.com">admin@getscribedash.com</a>.</p>
      </section>
    </LegalPageLayout>
  );
}
